/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppContactsRouteImport } from './routes/_app/contacts'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppLeagueRouteImport } from './routes/_app/league'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppPresentRouteImport } from './routes/_app/present'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppQueueRouteImport } from './routes/_app/queue'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin.index'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin.audit'
import { Route as AppAdminFlagsRouteImport } from './routes/_app/admin.flags'
import { Route as AppAdminSyncRouteImport } from './routes/_app/admin.sync'
import { Route as AppReluxesIndexRouteImport } from './routes/_app/reluxes.index'
import { Route as AppReluxesNewRouteImport } from './routes/_app/reluxes.new'
import { Route as AppRemindersReminderIdRouteImport } from './routes/_app/reminders.$reminderId'
import { Route as AppToolsIndexRouteImport } from './routes/_app/tools.index'
import { Route as AppToolsToolRouteImport } from './routes/_app/tools.$tool'
import { Route as AppVisitsNewRouteImport } from './routes/_app/visits.new'
import { Route as AppReluxesReluxIdIndexRouteImport } from './routes/_app/reluxes.$reluxId.index'
import { Route as AppReluxesReluxIdAmendRouteImport } from './routes/_app/reluxes.$reluxId.amend'
import { Route as AppReluxesDraftDraftIdRouteImport } from './routes/_app/reluxes.draft.$draftId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppLeagueRoute = AppLeagueRouteImport.update({
  id: '/league',
  path: '/league',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppPresentRoute = AppPresentRouteImport.update({
  id: '/present',
  path: '/present',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppQueueRoute = AppQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AppRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFlagsRoute = AppAdminFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSyncRoute = AppAdminSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppReluxesIndexRoute = AppReluxesIndexRouteImport.update({
  id: '/reluxes/',
  path: '/reluxes/',
  getParentRoute: () => AppRoute,
} as any)
const AppReluxesNewRoute = AppReluxesNewRouteImport.update({
  id: '/reluxes/new',
  path: '/reluxes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRemindersReminderIdRoute = AppRemindersReminderIdRouteImport.update({
  id: '/reminders/$reminderId',
  path: '/reminders/$reminderId',
  getParentRoute: () => AppRoute,
} as any)
const AppToolsIndexRoute = AppToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AppRoute,
} as any)
const AppToolsToolRoute = AppToolsToolRouteImport.update({
  id: '/tools/$tool',
  path: '/tools/$tool',
  getParentRoute: () => AppRoute,
} as any)
const AppVisitsNewRoute = AppVisitsNewRouteImport.update({
  id: '/visits/new',
  path: '/visits/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReluxesReluxIdIndexRoute = AppReluxesReluxIdIndexRouteImport.update({
  id: '/reluxes/$reluxId/',
  path: '/reluxes/$reluxId/',
  getParentRoute: () => AppRoute,
} as any)
const AppReluxesReluxIdAmendRoute = AppReluxesReluxIdAmendRouteImport.update({
  id: '/reluxes/$reluxId/amend',
  path: '/reluxes/$reluxId/amend',
  getParentRoute: () => AppRoute,
} as any)
const AppReluxesDraftDraftIdRoute = AppReluxesDraftDraftIdRouteImport.update({
  id: '/reluxes/draft/$draftId',
  path: '/reluxes/draft/$draftId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/contacts': typeof AppContactsRoute
  '/dashboard': typeof AppDashboardRoute
  '/league': typeof AppLeagueRoute
  '/notifications': typeof AppNotificationsRoute
  '/present': typeof AppPresentRoute
  '/products': typeof AppProductsRoute
  '/projects': typeof AppProjectsRoute
  '/queue': typeof AppQueueRoute
  '/share/$token': typeof ShareTokenRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/sync': typeof AppAdminSyncRoute
  '/reluxes/new': typeof AppReluxesNewRoute
  '/reminders/$reminderId': typeof AppRemindersReminderIdRoute
  '/tools/$tool': typeof AppToolsToolRoute
  '/visits/new': typeof AppVisitsNewRoute
  '/admin/': typeof AppAdminIndexRoute
  '/reluxes/': typeof AppReluxesIndexRoute
  '/tools/': typeof AppToolsIndexRoute
  '/reluxes/$reluxId/amend': typeof AppReluxesReluxIdAmendRoute
  '/reluxes/draft/$draftId': typeof AppReluxesDraftDraftIdRoute
  '/reluxes/$reluxId/': typeof AppReluxesReluxIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/account': typeof AppAccountRoute
  '/contacts': typeof AppContactsRoute
  '/dashboard': typeof AppDashboardRoute
  '/league': typeof AppLeagueRoute
  '/notifications': typeof AppNotificationsRoute
  '/present': typeof AppPresentRoute
  '/products': typeof AppProductsRoute
  '/projects': typeof AppProjectsRoute
  '/queue': typeof AppQueueRoute
  '/share/$token': typeof ShareTokenRoute
  '/': typeof AppIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/sync': typeof AppAdminSyncRoute
  '/reluxes/new': typeof AppReluxesNewRoute
  '/reminders/$reminderId': typeof AppRemindersReminderIdRoute
  '/tools/$tool': typeof AppToolsToolRoute
  '/visits/new': typeof AppVisitsNewRoute
  '/admin': typeof AppAdminIndexRoute
  '/reluxes': typeof AppReluxesIndexRoute
  '/tools': typeof AppToolsIndexRoute
  '/reluxes/$reluxId/amend': typeof AppReluxesReluxIdAmendRoute
  '/reluxes/draft/$draftId': typeof AppReluxesDraftDraftIdRoute
  '/reluxes/$reluxId': typeof AppReluxesReluxIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/contacts': typeof AppContactsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/league': typeof AppLeagueRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/present': typeof AppPresentRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/projects': typeof AppProjectsRoute
  '/_app/queue': typeof AppQueueRoute
  '/share/$token': typeof ShareTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/flags': typeof AppAdminFlagsRoute
  '/_app/admin/sync': typeof AppAdminSyncRoute
  '/_app/reluxes/new': typeof AppReluxesNewRoute
  '/_app/reminders/$reminderId': typeof AppRemindersReminderIdRoute
  '/_app/tools/$tool': typeof AppToolsToolRoute
  '/_app/visits/new': typeof AppVisitsNewRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/reluxes/': typeof AppReluxesIndexRoute
  '/_app/tools/': typeof AppToolsIndexRoute
  '/_app/reluxes/$reluxId/amend': typeof AppReluxesReluxIdAmendRoute
  '/_app/reluxes/draft/$draftId': typeof AppReluxesDraftDraftIdRoute
  '/_app/reluxes/$reluxId/': typeof AppReluxesReluxIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/account'
    | '/admin'
    | '/contacts'
    | '/dashboard'
    | '/league'
    | '/notifications'
    | '/present'
    | '/products'
    | '/projects'
    | '/queue'
    | '/share/$token'
    | '/admin/audit'
    | '/admin/flags'
    | '/admin/sync'
    | '/reluxes/new'
    | '/reminders/$reminderId'
    | '/tools/$tool'
    | '/visits/new'
    | '/admin/'
    | '/reluxes/'
    | '/tools/'
    | '/reluxes/$reluxId/amend'
    | '/reluxes/draft/$draftId'
    | '/reluxes/$reluxId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/account'
    | '/contacts'
    | '/dashboard'
    | '/league'
    | '/notifications'
    | '/present'
    | '/products'
    | '/projects'
    | '/queue'
    | '/share/$token'
    | '/'
    | '/admin/audit'
    | '/admin/flags'
    | '/admin/sync'
    | '/reluxes/new'
    | '/reminders/$reminderId'
    | '/tools/$tool'
    | '/visits/new'
    | '/admin'
    | '/reluxes'
    | '/tools'
    | '/reluxes/$reluxId/amend'
    | '/reluxes/draft/$draftId'
    | '/reluxes/$reluxId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/contacts'
    | '/_app/dashboard'
    | '/_app/league'
    | '/_app/notifications'
    | '/_app/present'
    | '/_app/products'
    | '/_app/projects'
    | '/_app/queue'
    | '/share/$token'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/flags'
    | '/_app/admin/sync'
    | '/_app/reluxes/new'
    | '/_app/reminders/$reminderId'
    | '/_app/tools/$tool'
    | '/_app/visits/new'
    | '/_app/admin/'
    | '/_app/reluxes/'
    | '/_app/tools/'
    | '/_app/reluxes/$reluxId/amend'
    | '/_app/reluxes/draft/$draftId'
    | '/_app/reluxes/$reluxId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupRoute: typeof SetupRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/league': {
      id: '/_app/league'
      path: '/league'
      fullPath: '/league'
      preLoaderRoute: typeof AppLeagueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/present': {
      id: '/_app/present'
      path: '/present'
      fullPath: '/present'
      preLoaderRoute: typeof AppPresentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queue': {
      id: '/_app/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AppQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/flags': {
      id: '/_app/admin/flags'
      path: '/flags'
      fullPath: '/admin/flags'
      preLoaderRoute: typeof AppAdminFlagsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/sync': {
      id: '/_app/admin/sync'
      path: '/sync'
      fullPath: '/admin/sync'
      preLoaderRoute: typeof AppAdminSyncRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/reluxes/': {
      id: '/_app/reluxes/'
      path: '/reluxes'
      fullPath: '/reluxes/'
      preLoaderRoute: typeof AppReluxesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reluxes/new': {
      id: '/_app/reluxes/new'
      path: '/reluxes/new'
      fullPath: '/reluxes/new'
      preLoaderRoute: typeof AppReluxesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reminders/$reminderId': {
      id: '/_app/reminders/$reminderId'
      path: '/reminders/$reminderId'
      fullPath: '/reminders/$reminderId'
      preLoaderRoute: typeof AppRemindersReminderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tools/': {
      id: '/_app/tools/'
      path: '/tools'
      fullPath: '/tools/'
      preLoaderRoute: typeof AppToolsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tools/$tool': {
      id: '/_app/tools/$tool'
      path: '/tools/$tool'
      fullPath: '/tools/$tool'
      preLoaderRoute: typeof AppToolsToolRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/visits/new': {
      id: '/_app/visits/new'
      path: '/visits/new'
      fullPath: '/visits/new'
      preLoaderRoute: typeof AppVisitsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reluxes/$reluxId/': {
      id: '/_app/reluxes/$reluxId/'
      path: '/reluxes/$reluxId'
      fullPath: '/reluxes/$reluxId/'
      preLoaderRoute: typeof AppReluxesReluxIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reluxes/$reluxId/amend': {
      id: '/_app/reluxes/$reluxId/amend'
      path: '/reluxes/$reluxId/amend'
      fullPath: '/reluxes/$reluxId/amend'
      preLoaderRoute: typeof AppReluxesReluxIdAmendRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reluxes/draft/$draftId': {
      id: '/_app/reluxes/draft/$draftId'
      path: '/reluxes/draft/$draftId'
      fullPath: '/reluxes/draft/$draftId'
      preLoaderRoute: typeof AppReluxesDraftDraftIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminFlagsRoute: typeof AppAdminFlagsRoute
  AppAdminSyncRoute: typeof AppAdminSyncRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminFlagsRoute: AppAdminFlagsRoute,
  AppAdminSyncRoute: AppAdminSyncRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppContactsRoute: typeof AppContactsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppLeagueRoute: typeof AppLeagueRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPresentRoute: typeof AppPresentRoute
  AppProductsRoute: typeof AppProductsRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppQueueRoute: typeof AppQueueRoute
  AppIndexRoute: typeof AppIndexRoute
  AppReluxesNewRoute: typeof AppReluxesNewRoute
  AppRemindersReminderIdRoute: typeof AppRemindersReminderIdRoute
  AppToolsToolRoute: typeof AppToolsToolRoute
  AppVisitsNewRoute: typeof AppVisitsNewRoute
  AppReluxesIndexRoute: typeof AppReluxesIndexRoute
  AppToolsIndexRoute: typeof AppToolsIndexRoute
  AppReluxesReluxIdAmendRoute: typeof AppReluxesReluxIdAmendRoute
  AppReluxesDraftDraftIdRoute: typeof AppReluxesDraftDraftIdRoute
  AppReluxesReluxIdIndexRoute: typeof AppReluxesReluxIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppContactsRoute: AppContactsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppLeagueRoute: AppLeagueRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPresentRoute: AppPresentRoute,
  AppProductsRoute: AppProductsRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppQueueRoute: AppQueueRoute,
  AppIndexRoute: AppIndexRoute,
  AppReluxesNewRoute: AppReluxesNewRoute,
  AppRemindersReminderIdRoute: AppRemindersReminderIdRoute,
  AppToolsToolRoute: AppToolsToolRoute,
  AppVisitsNewRoute: AppVisitsNewRoute,
  AppReluxesIndexRoute: AppReluxesIndexRoute,
  AppToolsIndexRoute: AppToolsIndexRoute,
  AppReluxesReluxIdAmendRoute: AppReluxesReluxIdAmendRoute,
  AppReluxesDraftDraftIdRoute: AppReluxesDraftDraftIdRoute,
  AppReluxesReluxIdIndexRoute: AppReluxesReluxIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupRoute: SetupRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
